


































































import { Vue, Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
import {
  RadioGroup,
  Radio,
  Toast,
  Calendar,
  Cell,
  DatetimePicker,
  Popup,
} from 'vant';
import { isWeiXin, getQueryString, WechatLogin } from '@/common/ts/common';
import { save } from '../api';
Vue.use(Radio)
  .use(RadioGroup)
  .use(Calendar)
  .use(Cell)
  .use(DatetimePicker)
  .use(Popup);
@Component
export default class Save extends Vue {
  radio1: string = '';
  radio2: string = '';
  radio3: string = '';
  radio4: string = '';
  radio5: string = '';
  radio6: string = '';
  show: boolean = false;
  dateShow: boolean = false;
  minDate: any = new Date(1950, 0, 1);
  maxDate: any = new Date(2025, 10, 1);
  name: string = '';
  gender: string = '';
  birthday: string = '';
  phone: string = '';
  onChange(e: any) {
    if (
      this.radio1 === '是' &&
      this.radio2 === '是' &&
      this.radio3 === '是' &&
      this.radio4 === '是' &&
      this.radio5 === '是'
    ) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
  change(id: any) {
    if (id === 1) {
      this.birthday = moment(this.birthday).format('L');
      this.dateShow = false;
    } else {
      this.dateShow = false;
    }
  }
  created() {
    const getUnionid = window.localStorage.getItem('unionid');
    if (!getUnionid) {
      WechatLogin();
    }
  }
  formatDate(date: any) {
    return `${date.getMonth() + 1}/${date.getDate()}`;
  }
  onConfirm(date: any) {
    this.dateShow = false;
    this.birthday = this.formatDate(date);
    console.log(123, this.birthday);
  }
  sub() {
    if (
      !this.radio1 ||
      !this.radio2 ||
      !this.radio3 ||
      !this.radio4 ||
      !this.radio5
    ) {
      Toast('提示请完成问卷调查');
      return false;
    } else if (
      this.radio1 !== '是' ||
      this.radio2 !== '是' ||
      this.radio3 !== '是' ||
      this.radio4 !== '是' ||
      this.radio5 !== '是'
    ) {
      Toast('谢谢参与');
      return false;
    } else {
      if (!this.name) {
        Toast('请输入你的姓名');
        return false;
      } else if (!this.radio6) {
        Toast('请输入你的性别');
        return false;
      } else if (!this.birthday) {
        Toast('请输入你的生日');
        return false;
      } else if (!this.phone || !/^1[345789][0-9]{9}$/.test(this.phone)) {
        Toast('请正确输入电话');
        return false;
      } else {
        this.save();
      }
    }
  }
  async save() {
    if (isWeiXin()) {
      const getUnionid = window.localStorage.getItem('unionid');
      const nickname = window.localStorage.getItem('nickname');
      const headimgurl = window.localStorage.getItem('headimgurl');
      const res = await save({
        unionid: getUnionid,
        wxName: nickname,
        wxImg: headimgurl,
        workType: 1,
        answer_one: this.radio1,
        answer_two: this.radio2,
        answer_three: this.radio3,
        answer_four: this.radio4,
        answer_five: this.radio5,
        name: this.name,
        sex: this.radio6,
        year: this.birthday,
        phone: this.phone,
      });
      Toast((res as any).msg);
      if ((res as any).code === 200) {
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
      }
    } else if (window.udid) {
      const res = await save({
        udid: window.udid,
        appkey: window.appkey,
        workType: 1,
        answer_one: this.radio1,
        answer_two: this.radio2,
        answer_three: this.radio3,
        answer_four: this.radio4,
        answer_five: this.radio5,
        name: this.name,
        sex: this.radio6,
        year: this.birthday,
        phone: this.phone,
      });
      Toast((res as any).msg);
      if ((res as any).code === 200) {
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
      }
    } else {
      Toast('请在微信或者上游新闻APP进行报名');
    }
  }
}
